import React, { createRef } from "react";
import './SearchLayer.css';
import $ from 'jquery';
import {ReactComponent as BackArrow} from '../../resources/images/arrow.svg';
import { Input } from "@material-ui/core";
import CancelIcon from "../../resources/wrappers/CancelIcon";
import SearchIcon from "../../resources/wrappers/SearchIcon";
import Media from "react-media";
import { AppUtils } from "../../utils/AppUtils";
import { IProductDto } from "../../models/ProductDto";
import { Route } from "react-router-dom";
import { ProductButton } from "../buttons/product-button/ProductButton";
import _ from "lodash";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";

export class SearchLayer extends React.Component<any,any>{
    private inputRef: any = null;
    constructor(props: any){
        super(props);

        this.state = {
            allProducts: [],
            inputValue: "",
            buttonDisabled: true,
            inputLength: 0,
            filtered: undefined,
            isSearchStarted: false,
            highlightedText: ""
        }

        this.inputRef = createRef();
        this.handleSearchTextInserted = this.handleSearchTextInserted.bind(this);
 /*        this.handleSearch = this.handleSearch.bind(this) */
    }

    componentDidMount(){
        if(this.props.location.state !== undefined && this.props.location.state.products !== undefined){
            console.log("Search products input OK");
            this.setState({allProducts: this.props.location.state.products});
        }

        if(!AppUtils.isPhoneOrTablet()){
            // Hide footer
            $("#desktop-footer-body").hide();
        }

        GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Ricerca prodotto', {});
    }

    componentWillUnmount(){
        if(!AppUtils.isPhoneOrTablet()){
            // Show footer
            $("#desktop-footer-body").show();
        }
    }

    private handleSearchTextInserted(event: any){
        if(!this.state.isSearchStarted)
        {
            this.setState({highlightedText: event.target.value})
        }

        this.setState({inputValue: event.target.value}, () => {
            this.setState({inputLength: this.state.inputValue.length}, () => {
                if(this.state.inputLength >= 3){
                    this.setState({buttonDisabled: false});
                } else {
                    this.setState({buttonDisabled: true});
                }
            })
        });
    }

    startSearch(){
        console.log("Start search...");
        let products: IProductDto[] = this.state.allProducts;
        let filteredForName = this.filterForName(products, this.state.inputValue);
        console.log("Name: " + filteredForName.length);
        let filteredForDescr = this.filterForDescription(products, this.state.inputValue);
        console.log("Desc: " + filteredForDescr.length);
        const unionWithDuplicates = [...filteredForName, ...filteredForDescr];
        console.log("Results: " + unionWithDuplicates.length);
        this.setState({filtered: this.arrayUnique(unionWithDuplicates)});
        this.setState({isSearchStarted: true})
        this.setState({highlightedText: this.state.inputValue})
        console.log("SEARCH STARTED WITH: " + this.state.inputValue)
        /* this.setState({isSearchStarted: true}) */
    }

    clean(){
        this.setState({inputValue: ""});
        this.setState({inputLength: 0});
        this.setState({buttonDisabled: true});
        this.setState({filtered: undefined});
    }

    filterForName(products: IProductDto[], toFilter: string): IProductDto[] {
        if(products === undefined || products === null){
            return [];
        } else {
            if(products.length === 0){
                return [];
            } else {
                return products.filter((element: IProductDto) => {
                    return element.name?.toLowerCase().includes(toFilter.toLowerCase());
                })
            }
        }
    }

    filterForDescription(products: IProductDto[], toFilter: string): IProductDto[] {
        if(products === undefined || products === null){
            return [];
        } else {
            if(products.length === 0){
                return [];
            } else {
                return products.filter((element: IProductDto) => {
                    return element.descr?.toLowerCase().includes(toFilter.toLowerCase());
                })
            }
        }
    }

    arrayUnique(array: any) {
        let a = array.concat();
        for(let i = 0; i < a.length; ++i) {
            for(let j = i+1; j < a.length; ++j) {
                if(a[i] === a[j])
                    a.splice(j--, 1);
            }
        }
    
        return a;
    }

    /* handleSearch() {
        this.setState({isSearchStarted: false});
    } */

    renderProducts(): JSX.Element {
        let elements = new Array<JSX.Element[]>();
        let temporary: JSX.Element[] = [];
        _.forEach(this.state.filtered, (value: IProductDto, index: number) => {
            if((index % 2) === 0){
                temporary.push(
                    <div className={"catalog-product-column catalog-product-column-left"}>
                        <Route render={({history}) => {
                            return <ProductButton highlightedText={this.state.highlightedText} product={value} history={history} page={'SearchLayer'} deleteFromCatalog={() => this.deleteProduct(value)}/>
                        }} />
                    </div>
                )
            } else {
                temporary.push(
                    <div className={"catalog-product-column catalog-product-column-right"}>
                        <Route render={({history}) => {
                            return <ProductButton highlightedText={this.state.highlightedText} product={value} history={history} page={'SearchLayer'} deleteFromCatalog={() => this.deleteProduct(value)}/>
                        }} />
                    </div>
                )
            }

            if(temporary.length === 2){
                elements.push(temporary);
                temporary = [];
            } else {
                if(index === (this.state.filtered?.length! - 1)){
                    elements.push(temporary);
                    temporary = [];
                }
            }
        });
        return (<div className={"catalog-product-table-container"}>
            {
                _.map(elements, (rowElements) => {
                    return <div className={"catalog-product-row"}>
                        {_.map(rowElements, (columnElement) => {
                            return columnElement;
                        })}
                    </div>
                })
            }
        </div>)
    }

    private deleteProduct(value: IProductDto){
        window.history.pushState(null, '', '/');
        this.props.history.push('/catalog', {data: {operation: 'deleteProductFromDetail', toDelete: value}});
    }

    render(){
        return <div id={"search-layer-full-page"}>
            <div className={"search-new-layer-main"}>
                <div className={"search-new-layer-header-container"}>
                    <div className={"search-new-layer-header-back"}>
                        <span style={{cursor: 'pointer'}}><BackArrow onClick={() => this.props.history.goBack()} className={"search-new-layer-icon"} /></span>
                    </div>
                    <div className={"search-new-layer-header-search"}>
                        <div className={"search-new-layer-searchbar"}>
                            <Input
                                disableUnderline={true}
                                id={"search-new-layer-input"}
                                /* placeholder={AppUtils.isPhoneOrTablet() ? "" : this.props.placeholder} */
                                placeholder={AppUtils.isPhoneOrTablet() ? "" : "Cerca Nome Prodotto o parola chiave"}
                                ref={this.inputRef}
                                value={this.state.inputValue}
                                onChange={this.handleSearchTextInserted}
                                autoFocus
                            />
                            <Media query="(min-width: 1065px)" render={() => {
                                return <div className={"search-new-layer-icons-container"}>
                                    {
                                        (this.state.inputLength >= 3) ? <span style={{cursor: 'pointer'}}><CancelIcon width={'30px'} height={'30px'} fill={'#D8D8D8'}
                                            onClick={() => this.clean()}/></span> : <SearchIcon width={'32px'} height={'32px'} fill={'#D8D8D8'} />
                                    }
                                </div>
                            }}/>
                            <Media query="(max-width: 1064px)" render={() => {
                                return <div className={"search-new-layer-icons-container"}>
                                    {
                                        (this.state.inputLength >= 3) ? <span style={{cursor: 'pointer'}}><CancelIcon width={'22px'} height={'22px'} fill={'#D8D8D8'}
                                            onClick={() => this.clean()}/></span> : undefined
                                    }
                                </div>
                            }}/>
                        </div>
                    </div>
                    <div className={"search-new-layer-header-send"}>
                            <Media query="(min-width: 1065px)" render={() => {
                                return <p className={this.state.buttonDisabled ? "search-new-layer-send-button-disabled" : "search-new-layer-send-button"}
                                onClick={this.state.buttonDisabled ? () => {} : () => {this.startSearch()} }>INVIA</p>
                            }}/>
                            <Media query="(max-width: 1064px)" render={() => {
                                return (this.state.inputLength >= 3) && <p className={this.state.buttonDisabled ? "search-new-layer-send-button-disabled" : "search-new-layer-send-button"}
                                onClick={this.state.buttonDisabled ? () => {} : () => {this.startSearch()} }>INVIA</p>
                            }}/>
                    </div>
                </div>
                <div className={"search-new-layer-search-content"}>
                    {
                        this.state.filtered !== undefined && <p className={"search-new-layer-label-founds"}>{this.state.filtered.length === 1 ? [<strong>1</strong>," prodotto trovato"] : [<strong>{this.state.filtered.length}</strong>, " prodotti trovati"]}</p>
                    }
                    {
                        this.state.filtered !== undefined && this.renderProducts()
                    }
                </div>
            </div>
        </div>
    }
}